// extracted by mini-css-extract-plugin
export default {"limits":"Limits__limits--725","control":"Limits__control--3Wp"};